import React from 'react';
import styles from './DeleteConfirmationModal.module.css';

const DeleteConfirmationModal = ({ itemName, onClose, onConfirm, loading }) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3>Confirm Deletion</h3>
          <button className={styles.closeBtn} onClick={onClose} disabled={loading}>×</button>
        </div>
        <div className={styles.modalBody}>
          <p>Are you sure you want to delete <strong>{itemName}</strong>?</p>
          <p className={styles.warningText}>This action cannot be undone.</p>
        </div>
        <div className={styles.modalFooter}>
          <button 
            className={`${styles.btn} ${styles.btnSecondary}`} 
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button 
            className={`${styles.btn} ${styles.btnDanger}`} 
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className={styles.spinnerBorder}></span> Deleting...
              </>
            ) : (
              'Delete'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;